import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Nav from "./Nav";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import dots from "../assets/images/dots.svg";
import http from "../services/http";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import DropdownRight from "./DropdownRight";
import { SpinnerCircular } from "spinners-react";
import arrowleft from "../assets/images/arrow-left.png";
import { Dropdown, Space } from "antd";

export default function TeamShark() {
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);

  const deleteCoachConfirmation = (id) => {
    setCoachID(id);
    setDeleteMessage("Are you sure you want to delete Assistant Coach?");
    setShowModal(true);
  };

  const deleteSwimmerConfirmation = (id, name) => {
    setSwimmerID(id);
    setDeleteMessage(`Are you sure you want to delete ${name}?`);
    setShowModal(true);
  };
  const { state } = useLocation();

  const [key, setKey] = useState("teamInfo");
  const [teamShark, setTeamShark] = useState({});
  const [swimmer, setSwimmer] = useState([]);
  const [coach, setCoach] = useState([]);
  const [loading, setLoading] = useState(true);

  const [email, setEmail] = useState([]);
  const params = useParams();
  // const [toggle, setToggle] = useState(true);
  const [uploadSpin, setUploadSpin] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState(
    "are you sure you want to delete?"
  );
  const [coachID, setCoachID] = useState(0);
  const [swimmerID, setSwimmerID] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredSwimmer, setFilteredSwimmer] = useState([]);
  const [sortColumn, setSortColumn] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc"); 

  const token = localStorage.getItem("xAuthToken");
  let user = localStorage.getItem("user");
  user = JSON.parse(user);

  const navigate = useNavigate();
  useEffect(() => {
    TeamShark();
    if (state && (state.previousPath === "/swimmerLocker" || state.previousPath === "/editDetails") ) {
      InProgress("swimmers");
    }
  }, []);

  const TeamShark = async () => {
    setLoading(true);
      http
        .get(`api/admin/team/${params.id}?token=${token}`)
        .then((res) => {
          setEmail(res.data.email);
          setTeamShark(res.data);
          console.log("team====>", swimmer);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
  };
  const DeleteAssistantCoach = async () => {
    setUploadSpin(true);

    http
      .delete(`/api/admin/coach/assistcoaches/${coachID}?token=${token}`)
      .then((res) => {
        console.log("response---", res.data.message);
        setCoach(coach.filter((element) => element.id !== coachID));
        setUploadSpin(false);
        handleClose();
      })
      .catch((error) => {
        setUploadSpin(false);
      });
  };

  const DeleteSwimmer = async () => {
    setUploadSpin(true);

    http
      .delete(`api/swimmer/${swimmerID}?token=${token}`)
      .then((res) => {
        setSwimmer(swimmer.filter((element) => element.id !== swimmerID));
        setSwimmerID(0);
        setUploadSpin(false);
        handleClose();
        InProgress("swimmers")
      })
      .catch((error) => {
        setUploadSpin(false);
      });
  };

  const handelConfirmation = () => {
    if (coachID !== 0) {
      DeleteAssistantCoach();
    } else if (swimmerID !== 0) {
      DeleteSwimmer();
    }
  };

  const InProgress = (k) => {
    setKey(k);
    switch (k) {
      case "teamInfo":
        setLoading(true);

        http
          .get(`api/admin/team/${params.id}?token=${token}`)
          .then((res) => {
            setTeamShark(res.data);
            console.log("team 2====>", swimmer);
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
          });
        break;

      case "swimmers":
        setLoading(true);
        setSearchQuery('')
        setSortColumn("name")
        setSortOrder("asc")

        http
          .get(`api/swimmer/getbyteam/${params.id}?token=${token}`)
          .then((res) => {
            setSwimmer(res.data);
            console.log("swimmer====>", swimmer);
            setFilteredSwimmer(res.data);
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
        break;
      case "coach":
        setLoading(true);

        http
          .get(
            `api/admin/coach/assistcoaches/byteam/${params.id}?token=${token}`
          )
          .then((res) => {
            setCoach(res.data);
            console.log("coach====>", res.data);
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
          });
        break;
      default:
        break;
    }
  };

  const handleSearchChange = (event) => {
    const query = event.target.value.toLowerCase();
    setSearchQuery(query);
    filterSwimmers(query);
  };

  const filterSwimmers = (query) => {
    if (!query) {
      // setFilteredSwimmer(swimmer);
      handleSort(sortColumn,sortOrder === "asc" ? "desc" : "asc")
      return;
    }

    const filtered = swimmer.filter(
      (s) =>
        `${s.firstname} ${s.lastname}`.toLowerCase().includes(query) ||
        s.groupName.toLowerCase().includes(query) 
        // ||`${s.parentFirstname} ${s.parentLastname}`.toLowerCase().includes(query)
    );
    setFilteredSwimmer(filtered);
  };

  const handleSort = (column,orderDirection) => {
    const order = orderDirection === "asc" ? "desc" : "asc";
    setSortOrder(order);
    setSortColumn(column);

    const sortedData = [...swimmer].sort((a, b) => {
      const aValue = column === "name" ? `${a.firstname} ${a.lastname}` : a[column];
      const bValue = column === "name" ? `${b.firstname} ${b.lastname}` : b[column];
      if (aValue < bValue) return order === "asc" ? -1 : 1;
      if (aValue > bValue) return order === "asc" ? 1 : -1;
      return 0;
    });

    setFilteredSwimmer(sortedData);
  };

  const getSortIcon = (column) => {
    if (sortColumn === column) {
      return sortOrder === "asc" ? "↑" : "↓";
    }
    return "↑↓"; // No icon if it's not the sorted column
  };


  return (
    <body>
      <div className="wrapper">
        <Nav
        // sidebarClass={toggle ? "show" : "hide"}
        />

        <div id="content">
          <header>
            <div className="dashboard_header">
              <div className="left-side d-flex ">
                <button
                  onClick={() => navigate("/teams")}
                  type="button"
                  className="btn btn-link  "
                >
                  <img alt="" src={arrowleft} className="img-fluid" />
                </button>
                <h1>{teamShark.name}</h1>
              </div>
              <DropdownRight />
            </div>
          </header>
          <div className="dashbord_content">
            <div className="analysts-wraper-head">
              <div className="personal_and_bank_info Analysts_tabs Intermediate">
                <div className="map_btn">
                  <div className="search_btn_added">
                    {key === "swimmers" && (
                      <input
                        type="text"
                        placeholder="Name, Group..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        style={{
                          marginRight: 20,
                          padding: 10,
                          border: "1px solid #ccc",
                          borderRadius: 4,
                        }}
                      />
                    )}{" "}
                    <Link
                      to="/editTeamInfo"
                      className=" them_btn"
                      state={{
                        id: teamShark.id,
                      }}
                    >
                      Edit Team Info
                    </Link>
                  </div>
                </div>
                <Tabs
                  activeKey={key}
                  onSelect={(k) => InProgress(k)}
                  style={{
                    alignItems: "center",
                    // width: 370,
                    borderRadius: 5,
                    // margin: 0,
                    backgroundColor: "#f6f6f6",
                    padding: 10,
                  }}
                  defaultActiveKey="profile"
                  id="uncontrolled-tab-example"
                  className="mb-3 nav nav-pills border-bottom-0"
                >
                  <Tab
                    eventKey="teamInfo"
                    title=" Team Info"
                    style={{ marginTop: 40 }}
                  >
                    <div className="row team_card">
                      <div className="col-lg-6">
                        <div className="card">
                          <div className="head">
                            <h5>Personal Data</h5>
                          </div>
                          <div className="card-inner">
                            <div className="row">
                              <div className="col-5">
                                <div className="row">
                                  <div className="col-12">
                                    <h5>Team Name</h5>
                                    <h5>Coach Name</h5>
                                    <h5>Cell Number</h5>
                                    <h5>Pool Address</h5>
                                    <h5>Mailing Address</h5>
                                  </div>
                                </div>
                              </div>
                              <div className="col-7">
                                <div className="row">
                                  <div className="col-12">
                                    <div className="d-flex flex-column">
                                      <p>
                                        {teamShark.name ? <span>{teamShark.name}</span> : ""}
                                      </p>
                                      <p>
                                        {teamShark.coach ? <span>{teamShark.coach}</span> : ""}
                                      </p>
                                      <p>
                                        {teamShark.cell_number ? <span>{teamShark.cell_number}</span> : ""}
                                      </p>
                                      <p>
                                        {teamShark.pool_address ? <span>{teamShark.pool_address}</span> : ""}
                                      </p>
                                      <p>
                                        {teamShark.mailing_address ? <span>{teamShark.mailing_address}</span> : ""}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div className="col-lg-6">
                        <div className="card h_auto">
                          <div className="head">
                            <h5>Banking Info</h5>
                          </div>
                          <div className="card-inner">
                            <div className="row">
                              <div className="col-5">
                                <h5>Bank Name</h5>
                                <h5>Account Number</h5>
                                <h5>Routing Number</h5>
                                <h5>Subscription</h5>
                              </div>
                              <div className="col-7">
                                <p>
                                  {teamShark?.bank_name ? (
                                    <div
                                      style={{
                                        width: 250,
                                        height: 30,
                                      }}
                                    >
                                      <p>{teamShark?.bank_name}</p>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </p>
                                <p>
                                  {teamShark?.account_number ? (
                                    <div
                                      style={{
                                        width: 250,
                                        height: 30,
                                      }}
                                    >
                                      <p>{teamShark?.account_number}</p>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </p>
                                <p>
                                  {teamShark?.routing_number ? (
                                    <div
                                      style={{
                                        width: 250,
                                        height: 30,
                                      }}
                                    >
                                      <p>{teamShark?.routing_number}</p>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </p>
                                <p className="text_green">
                                  {teamShark?.payment_type === 1
                                    ? "Single pay"
                                    : "Monthly pay"}{" "}
                                  -$ {teamShark.price}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                  <Tab
                    eventKey="swimmers"
                    title="Swimmers"
                    style={{ marginTop: 40 }}
                  >
                    {/* <div className="table_vedio_upload mb_30 mb-0"> */}
                    <div className="table_vedio_upload dashbord_table     mb_30 over_flow mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            {/* <th
                              className="custom-header"
                              style={{ minWidth: "200px" }}
                            >
                              ID
                            </th> */}
                            <th
                            // className="custom-header"
                            // style={{ minWidth: "180px" }}
                            onClick={() => handleSort("name",sortOrder)} style={{ cursor: "pointer" }}
                            >
                              Swimmer Name {getSortIcon("name")}
                            </th>
                            <th
                            // className="custom-header"
                            // style={{ minWidth: "130px" }}
                            onClick={() => handleSort("groupName",sortOrder)} style={{ cursor: "pointer" }}
                            >
                              Group {getSortIcon("groupName")}
                            </th>
                            {/* <th
                              className="custom-header"
                              style={{ minWidth: "110px" }}
                            >
                              Age
                            </th>
                            <th
                              className="custom-header"
                              style={{ minWidth: "130px" }}
                            >
                              Birthdate
                            </th>
                            <th
                              className="custom-header"
                              style={{ minWidth: "180px" }}
                            >
                              Parent Name
                            </th> */}
                            <th onClick={() => handleSort("gender")} style={{ cursor: "pointer" }}>Gender {getSortIcon("gender",sortOrder)}</th>
                            <th
                            // className="custom-header"
                            // style={{ minWidth: "150px" }}
                            >
                              Cell Number
                            </th>
                            {/* <th
                              className="custom-header"
                              style={{ minWidth: "200px" }}
                            >
                              Parent ID
                            </th> */}
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                position: "absolute",
                                top: 0,
                                left: 250,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 100,
                              }}
                            >
                              <SpinnerCircular size="5%" className="loader-position" />
                            </div>
                          ) : (
                            filteredSwimmer?.map((item, index) => (
                              <tr key={`${item.id}${index}`}>
                                {/* <td className="custom-cell">{item.id}</td> */}
                                {/* <td className="custom-cell">{`${
                                  item.firstname
                                } ${item.lastname || ""}`}</td> */}
                                <td className="custom-cell">
                                  <Link
                                     to="/swimmerLocker"
                                     state={{
                                       id: item.id,
                                       name: `${item.firstname} ${item.lastname}`,
                                       swimmer: item,
                                       teamId:params.id
                                     }}
                                    className="swimmer-name-link"
                                  >
                                    {`${item.firstname} ${item.lastname || ""}`}
                                  </Link>
                                </td>
                                <td className="custom-cell">
                                  {item.groupName}
                                </td>
                                {/* <td className="custom-cell">{item.age}</td>
                                <td className="custom-cell">
                                  {item.birthday
                                    ? moment(item.birthday).format(
                                        "MMM Do YYYY"
                                      )
                                    : ""}
                                </td>
                                <td className="custom-cell">{`${
                                  item.parentFirstname || ""
                                } ${item.parentLastname || ""}`}</td> */}
                                <td className="custom-cell">{item.gender}</td>

                                <td className="custom-cell">
                                  {item.parentPhone}
                                </td>
                                {/* <td className="custom-cell">{item.parent_id || "-"}</td> */}
                                <td className="custom-cell">
                                  <div className="dropdown wraper_btn">
                                    <Dropdown
                                      menu={{
                                        items: [
                                          {
                                            label: (
                                              <Link
                                                to="/swimmerLocker"
                                                state={{
                                                  id: item.id,
                                                  name: `${item.firstname} ${item.lastname}`,
                                                  swimmer: item,
                                                  teamId:params.id
                                                }}
                                                className="btn shadow-none"
                                                style={{
                                                  backgroundColor: "white",
                                                }}
                                              >
                                                View Profile
                                              </Link>
                                            ),
                                            key: "0",
                                          },
                                          {
                                            label: (
                                              <Link
                                                to="/editDetails"
                                                state={{
                                                  id: item.id,
                                                  name: `${item.firstname} ${item.lastname}`,
                                                  swimmer: item,
                                                }}
                                                className="btn shadow-none"
                                                style={{
                                                  backgroundColor: "white",
                                                }}
                                              >
                                                Edit Profile
                                              </Link>
                                            ),
                                            key: "1",
                                          },
                                          {
                                            label: (
                                              <button
                                                onClick={() =>
                                                  deleteSwimmerConfirmation(
                                                    item.id,
                                                    `${item.firstname} ${item.lastname}`
                                                  )
                                                }
                                                className="btn shadow-none"
                                                style={{
                                                  backgroundColor: "white",
                                                }}
                                                aria-label={`Delete ${item.firstname} ${item.lastname} Profile`}
                                                tabIndex="0"
                                              >
                                                Delete Profile
                                              </button>
                                            ),
                                            key: "2",
                                          },
                                        ],
                                      }}
                                      trigger={["click"]}
                                    >
                                      <a onClick={(e) => e.preventDefault()}>
                                        <Space>
                                          <img
                                            src={dots}
                                            className="img-fluid"
                                            style={{ width: 25 }}
                                            alt="menu"
                                          />
                                        </Space>
                                      </a>
                                    </Dropdown>
                                  </div>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </Tab>
                  <Tab
                    eventKey="coach"
                    title="Assistant coaches"
                    style={{ marginTop: 40 }}
                  >
                    <div className="table_vedio_upload dashbord_table mb_30 mb-0">
                      <table className="table table-borderless table-responsive-md">
                        <thead>
                          <tr>
                            {/* <th scope="col" className="  pl_25">
                              ID
                            </th> */}
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            {/*  <th scope="col"></th> */}
                            <th scope="col">
                              <div className="map_btn">
                                {" "}
                                <Link
                                  to="/addNewAssistant"
                                  state={{
                                    id: params.id,
                                  }}
                                  style={{ padding: 10 }}
                                >
                                  <button
                                    className="them_btn_oulinebtnname"
                                    style={{ marginLeft: 20 }}
                                  >
                                    Add New
                                  </button>
                                </Link>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <div
                              style={{
                                position: "absolute",
                                marginTop: 250,
                                backgroundColor: "#ffffffc2",
                                marginLeft: 580,

                                backgroundBlendMode: "overlay",
                                zIndex: 100,
                              }}
                            >
                              <SpinnerCircular size="15%" />
                            </div>
                          ) : (
                            <>
                              {coach?.map((item, i) => (
                                <tr key={`${item.id}${i}`}>
                                  {/* <td className="pl_25">{item.id}</td> */}
                                  <td>{item.name}</td>
                                  <td>{item.email}</td>

                                  <td>
                                    <div className="dropdown wraper_btn">
                                      <Dropdown>
                                        <Dropdown.Toggle
                                          className="btn dropdown-toggle"
                                          variant="success"
                                          id="dropdown-basic"
                                        >
                                          <img
                                            alt=""
                                            src={dots}
                                            className="img-fulid"
                                          />
                                          <span className="caret"></span>
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu
                                          as="ul"
                                          className="dropul"
                                        >
                                          <Dropdown.Item
                                            as="li"
                                            onClick={() =>
                                              deleteCoachConfirmation(item.id)
                                            }
                                          >
                                            Delete
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </td>
                                  {/* <td></td> */}
                                </tr>
                              ))}
                            </>
                          )}
                        </tbody>
                      </table>
                      <p className="text-table-show">
                        {" "}
                        {/* Showing 8 out of 132 entries */}
                      </p>
                    </div>
                  </Tab>
                </Tabs>
                {user.data.role === 0 ? (
                  <>
                    {/* <div>
                        <Link
                          to={`/advancedSecuritySettings/${email}`}
                          // state={{ email: email }}
                          // to="/advancedSecuritySettings"
                          className="btn-link mt_40 d-block text-left my-4"
                          data-target="#new_team_add"
                        >
                          <img src={settings} className="mr-3" />
                          Advanced Security Settings
                        </Link>
                      </div> */}
                  </>
                ) : (
                  <></>
                )}
              </div>

              <Modal
                className="starrating"
                show={showModal}
                onHide={handleClose}
              >
                <Modal.Header>
                  <Modal.Title as="h5">Are you sure?</Modal.Title>
                  <button
                    onClick={handleClose}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    {" "}
                    <span aria-hidden="true">&times;</span>{" "}
                  </button>
                </Modal.Header>
                <Modal.Body>
                  <div className="raing_star">
                    <p>{deleteMessage}</p>
                  </div>
                  <div className="modal-footer border-top-0">
                    <button
                      onClick={handleClose}
                      type="button"
                      className=" them_btn_ouline  "
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handelConfirmation}
                      type="button"
                      className="them_btn1 "
                      data-toggle="modal"
                      data-target="#new_team_add_yes"
                    >
                      {uploadSpin ? <SpinnerCircular /> : " Yes"}
                    </button>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </body>
  );
}
